<template>
  <div>
    <el-row class="indoorSettingImg">
      <!--          内景图-->
      <indoor-setting :category-tag-id="tagSelected" :space-id="currentSpaceInfo.id"
                      @showDeviceDetail="showDetail"/>
    </el-row>
    <!--<ul class="deviceTypeUl">-->
    <!--  <li :key="item.id" class="deviceTypeLi" v-for="item in tagList">-->
    <!--    <input :checked="item.isCheck" :class="item.class" :ref="item.class"-->
    <!--           @change="changeInput(item.id,item.name)"-->
    <!--           name="deviceTag"-->
    <!--           type="radio"/>-->
    <!--    <div>{{ item.name }}态势</div>-->
    <!--  </li>-->
    <!--</ul>-->
  </div>
</template>

<script>
import {overviewComponents} from "@/assets/js/components/overview";
import IndoorSetting from "@/views/dcim_vue_app/device_map/IndoorSetting";
import {deleteByPageAndComponentName, getCustomListByPage, savePage} from "@/network/device-custom-page";
import {getSystematicByCodes} from "@/network/systematic";
import {getListByParentCode} from "@/network/extension";
import lodash from "lodash";

export default {
  name: "IndoorSettingView",
  components: {
    IndoorSetting
  },
  props: ['currentSpaceInfo', 'tagCode'],
  data() {
    return {
      pageUrl: 'overview',
      tagList: [],
      tagSelected: '',
      tagSelectedCode: '',
      trendExtendData: null,
      modelListVisible: false,
      componentList: overviewComponents.map(item => ({...item})), //所有模块
      initComponentList: [], //所有初始化模块
      modelList: [], //模块列表
      leftList: [], //点击时左边页面模块
      rightList: [],//点击时右边页面模块
      leftModelList: [], //当前左边页面模块
      rightModelList: [],//当前右边页面模块
      labelName: "动力",
      drag: false,
      deviceCustomLayouts: []
    };
  },
  created() {
    this.formatAllComponents()
  },
  methods: {
    //获取页面布局
    getCustomListByPage() {
      getCustomListByPage(this.pageUrl).then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.deviceCustomLayouts = res.data[0].deviceCustomLayouts
            this.formatCustomComponents()
          } else {
            this.saveCustomPage();
          }
        }
      })
    },
    //格式化所有组件
    formatAllComponents() {
      getSystematicByCodes("capacity_system").then(res => {
        if (res.code === 0) {
          this.initComponentList = [];
          if (res.data.length < 1 || res.data[0].val1 === 'false') {
            this.componentList = this.componentList.filter(item => item.component !== 'comprehensive_situation/EnergyEfficiency')
          } else {
            this.componentList = lodash.cloneDeep(overviewComponents)
          }
          this.componentList.forEach(item => {
            let component = item;
            component.initComponent = () => import('@/components/component/' + item.component + '.vue');
            this.initComponentList.push(lodash.cloneDeep(component))
          })
          this.getTags();
        }
      })
    },
    //获取当前页面模块和模块列表
    formatCustomComponents() {
      const leftModelList = []
      const rightModelList = []
      const name = [];
      this.deviceCustomLayouts.forEach(item => {
          this.initComponentList.forEach(initComponent => {
            if (item.component === initComponent.component) {
              let params = JSON.parse(item.params)
              name.push(item.component);
              initComponent.params = params
              let param = params.filter(param => param.tag === this.tagSelectedCode)
              if (param.length > 0) {
                if (param[0].direction === 'left' && param[0].display) {
                  leftModelList.push(initComponent)
                } else if (param[0].direction === 'right' && param[0].display) {
                  rightModelList.push(initComponent)
                } else if (!param[0].display) {
                  name.forEach((i, index) => {
                    if (i === item.component) {
                      name.splice(index, 1)
                    }
                  })
                }
              }
            }
          })
        }
      )
      this.leftModelList = this.sortDeviceCustomLayouts(leftModelList)
      this.rightModelList = this.sortDeviceCustomLayouts(rightModelList)
      this.modelList = this.initComponentList.filter(item => {
        return name.indexOf(item.component) < 0;
      });
    },
    // 获取设备标签
    getTags() {
      getListByParentCode("device_category_tag").then(res => {
        if (res.code === 0) {
          const tags = [];
          res.data = res.data.filter(item => item.isDisplay)
          res.data.forEach((item, index) => {
            item.isCheck = false;
            item.class = item.code.split("_")[0];
            if (this.tagCode) {
              if (this.tagCode === item.code) {
                this.tagSelected = item.id;
                this.tagSelectedCode = item.code;
                item.isCheck = true;
                item.class = item.class + "-selected";
                this.getCustomListByPage();
              }
            } else {
              if (index === 0) {
                this.tagSelected = item.id;
                this.tagSelectedCode = item.code;
                item.isCheck = true;
                item.class = item.class + "-selected";
                this.getCustomListByPage();
              }
            }
            tags.push(item);
          })
          this.tagList = tags;
        }
      })
    },
    //更换选中图标
    changeInput(id, name) {
      this.$emit('childByValue', name)
      this.tagList.map(item => {
        if (item.id === id) {
          this.tagSelected = id
          this.tagSelectedCode = item.code
          this.labelName = item.name
          if (item.class.indexOf("-selected") < 0) {
            item.class = this.$refs[item.class][0].className + '-selected'
          }
          item.isCheck = true
          this.formatCustomComponents();
        } else {
          if (item.class.indexOf("-selected") > -1) {
            const index = item.class.lastIndexOf("-");
            item.class = item.class.substring(0, index);
          }
          item.isCheck = false
        }
      })
    },
    showDetail(deviceId) {
      this.$refs.deviceDetail.showDeviceDetails(deviceId);
    },
    //展示所有模块
    showModelList() {
      this.modelListVisible = !this.modelListVisible
    },
    //鼠标点击选中要拖拽元素时的事件
    chooseEvent() {
      this.drag = !this.drag
      this.leftList = this.leftModelList
      this.rightList = this.rightModelList
    },
    //选中后松开鼠标的事件
    unChooseEvent(direction) {
      this.drag = !this.drag
      let diffArray = []
      let display;
      if (this.leftList.length + this.rightList.length === this.leftModelList.length + this.rightModelList.length) {
        //左右移动模块
        if (this.leftList.length > this.leftModelList.length) {
          //左往右移动
          diffArray = this.setPositionDirection(this.rightModelList, this.rightList, 'right')
        } else if (this.leftList.length === this.leftModelList.length) {
          //上下移动
          if (direction === 'left') {
            diffArray = this.leftModelList
          } else if (direction === 'right') {
            diffArray = this.rightModelList
          }
        } else {
          //右往左移动
          diffArray = this.setPositionDirection(this.leftModelList, this.leftList, 'left')
        }
      } else {
        //添加或删除模块
        if (this.leftList.length > this.leftModelList.length) {
          //左边删除
          display = false
          diffArray = this.getDiffLayout(this.leftList, this.leftModelList)
        } else if (this.leftList.length < this.leftModelList.length) {
          //左边添加
          display = true
          diffArray = this.setPositionDirection(this.leftModelList, this.leftList, 'left')
        } else {
          if (this.rightList.length > this.rightModelList.length) {
            //右边删除
            display = false
            diffArray = this.getDiffLayout(this.rightList, this.rightModelList)
          } else if (this.rightList.length < this.rightModelList.length) {
            //右边添加
            display = true
            diffArray = this.setPositionDirection(this.rightModelList, this.rightList, 'right')
          }
        }
      }
      this.saveCustomPage(diffArray, display)
    },
    // 获取差集布局 arr1>arr2
    getDiffLayout(arr1, arr2) {
      return arr1.filter(item => arr2.indexOf(item) === -1)
    },
    //设置差集布局位置
    setPositionDirection(arr1, arr2, direction) {
      arr1.map(item => {
        if (arr2.indexOf(item) === -1) {
          item.position.map(position => {
            if (position.tag === this.tagSelectedCode) {
              position.direction = direction
            }
          })
        }
      })
      return arr1
    },
    // 布局修改排序
    setPositionSort(modelList, display) {
      modelList.map((model, index) => {
        model.position = model.position.map(item => {
          if (item.tag === this.tagSelectedCode) {
            item.sort = index + 1;
            if (display !== undefined) {
              item.display = display
            }
          }
          return item
        })
        return model
      })
      return modelList
    },
    //布局排序显示
    sortDeviceCustomLayouts(modelList) {
      modelList = modelList.sort((a, b) => {
        const aPosition = a.params.filter(param => param.tag === this.tagSelectedCode)[0]
        const bPosition = b.params.filter(param => param.tag === this.tagSelectedCode)[0]
        return aPosition.sort - bPosition.sort
      })
      return modelList
    },
    //保存页面布局
    saveCustomPage(modelList, display) {
      if (!modelList) {
        modelList = lodash.cloneDeep(this.componentList);
      } else {
        modelList = this.setPositionSort(modelList, display)
      }
      const deviceCustomPageDto = {};
      const deviceCustomLayouts = []
      modelList.forEach(item => {
        item.params = JSON.stringify(item.position)
        deviceCustomLayouts.push(item);
      })
      if (deviceCustomLayouts.length > 0) {
        const deviceCustomPage = {};
        deviceCustomPage.page = this.pageUrl;
        deviceCustomPageDto.deviceCustomLayouts = deviceCustomLayouts;
        deviceCustomPageDto.deviceCustomPage = deviceCustomPage;
        savePage(deviceCustomPageDto).then(() => {
          this.getCustomListByPage();
        })
      }
    },
    //恢复默认
    restore() {
      this.$confirm('是否恢复默认设置', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            //删除所有布局
            deleteByPageAndComponentName(this.pageUrl).then(res => {
              if (res.code === 0) {
                this.modelListVisible = false;
                this.formatAllComponents();
              }
            })
          }
        }
      });
    }
  }
}
</script>

<style scoped>

.overview .el-card {
  margin: 0;
}

.overview .el-card >>> .el-card__header {
  border-bottom-color: #299ffb5c;
}

.tagPic {
  background-image: url('../../../assets/images/index/room-line.png');
  height: 32px;
  background-position: 0 46%;
  background-repeat: no-repeat;
}

.deviceTypeUl {
  padding-left: 10px;
  text-align: center;
  /*margin-bottom: 0;*/
}

.deviceTypeLi {
  list-style: none;
  margin-right: 30px;
  display: inline-block;
}

input[type="radio"] {
  -webkit-appearance: none;
  border: none;
  width: 49px;
  height: 50px;
}

.power {
  background: url("../../../assets/images/comprehensive/动力设备.png") center no-repeat;
}

.power-selected {
  background: url("../../../assets/images/comprehensive/动力设备选中.png") center no-repeat;
}

.environment {
  background: url("../../../assets/images/comprehensive/环境设备.png") center no-repeat;
}

.environment-selected {
  background: url("../../../assets/images/comprehensive/环境设备选中.png") center no-repeat;
}

.fire {
  background: url("../../../assets/images/comprehensive/消防设备.png") center no-repeat;
}

.fire-selected {
  background: url("../../../assets/images/comprehensive/消防设备选中.png") center no-repeat;
}

.security {
  background: url("../../../assets/images/comprehensive/安防设备.png") center no-repeat;
}

.security-selected {
  background: url("../../../assets/images/comprehensive/安防设备选中.png") center no-repeat;
}

.network {
  background: url("../../../assets/images/comprehensive/网络设备.png") center no-repeat;
}

.network-selected {
  background: url("../../../assets/images/comprehensive/网络设备选中.png") center no-repeat;
}

.elevator {
  background: url("../../../assets/images/comprehensive/梯控.png") center no-repeat;
}

.elevator-selected {
  background: url("../../../assets/images/comprehensive/梯控选中.png") center no-repeat;
}

.water {
  background: url("../../../assets/images/comprehensive/给排水.png") center no-repeat;
}

.water-selected {
  background: url("../../../assets/images/comprehensive/给排水选中.png") center no-repeat;
}

.synthesize {
  background: url("../../../assets/images/comprehensive/停车.png") center no-repeat;
}

.synthesize-selected {
  background: url("../../../assets/images/comprehensive/停车选中.png") center no-repeat;
}

.indoorSetting {
  width: calc(60vw - 43px);
  margin: 0 20px;
  display: inline-block
}

.indoorSettingImg {
  width: 100%;
  /*min-height: 700px;*/
  min-height: 27vh !important;
  height: 90vh !important;
  text-align: center;
  overflow: auto;
}

.listIcon {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: rgba(41, 155, 255, .2);
  text-align: center;
  line-height: 32px;
}

.draggable {
  width: 20vw;
  height: 90vh;
  overflow-y: auto;
}

.draggableLeft {
  float: left;
}

.draggableBorder {
  border: 1px solid #07E6F8;
}

.draggableRight {
  float: right;
}

.draggableGroup {
  height: 100%;
  display: block;
}

.modelListDiv {
  width: 200px;
  margin: 20px;
  right: 0;
  top: 70px;
  position: absolute;
  background-color: rgba(36, 75, 100, .9);
  z-index: 10;
}

.move {
  cursor: move;
}

.pageModelItem {
  margin-bottom: 20px;
}

@media (max-width: 1420px) {
  .draggable {
    width: 25vw;
  }

  .indoorSetting {
    width: calc(50vw - 43px);
  }
}

@media (max-width: 1020px) {
  .draggable {
    width: 48%;
  }

  .indoorSetting {
    width: 48%;
    margin: 20px 0;
  }

  .indoorSetting {
    width: 100%;
  }

  .indoorSettingImg {
    height: auto;

  }
}

@media (max-width: 500px) {
  .draggable {
    width: 100%;
    min-height: 20vh;
    height: auto;
  }

  .indoorSetting {
    width: 100%;
    margin: 20px 0;
    height: auto;
  }

  .indoorSettingImg {
    height: auto;
    min-height: 20vh;
    overflow: hidden;
  }
}

</style>
